<div class="d-flex">
  <div
    class="{{
      selectedOption === EServiceChangeRequestToggleHeaders.PREVIEW ||
      selectedOption === EServiceChangeRequestToggleHeaders.CODE_EDITOR
        ? 'col-1'
        : 'w-25'
    }} mt-5 ms-3">
    <irembogov-service-request-header-togger-widget
      [isColumn]="
        selectedOption === EServiceChangeRequestToggleHeaders.WIZARD
          ? false
          : true
      "
      [options]="headerOptions"
      [selectedOption]="selectedOption"
      (selectOption)="onSelectOptionChange($event)"
      class="pl-2"></irembogov-service-request-header-togger-widget>
    <div class="workflow-menu w-100">
      <div
        class="configure-stepper-nav-items"
        *ngIf="selectedOption === EServiceChangeRequestToggleHeaders.WIZARD">
        <div
          class="config-navs d-flex flex-column align-items-start bg-white"
          style="height: 100%">
          <button
            *ngFor="let step of workflowSteps; let index = index"
            [class]="{
              selected: index === currentConfigStep,
              linkitem: true,
              completed: step.isComplete,
              'w-100': true
            }"
            (click)="OnStepperChange(index)"
            [style.background-color]="
              index === currentConfigStep ? '#EAF4FF' : ''
            ">
            <div class="d-flex justify-content-start">
              <div class="">
                <i
                  aria-hidden="true"
                  [class]="
                    workflowSteps[index].icon
                      ? workflowSteps[index].icon + ' me-2'
                      : 'me-2'
                  "
                  *ngIf="!step.isComplete"></i>
              </div>
              <div class="d-flex flex-column justify-content-start text-left">
                <span
                  style="
                    font-size: 16px;
                    font-weight: 500;
                    font-style: normal;
                    text-align: left;
                    color: #757c8a;
                  "
                  ><span *ngIf="false">{{ index + 1 }}.&nbsp;</span
                  >{{ step.label }}</span
                >
                <span
                  style="
                    font-size: 12px;
                    font-weight: 400;
                    font-style: normal;
                    text-align: left;
                  "
                  class="text-muted"
                  >{{ step.subLabel }}</span
                >
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="ms-5 me-3 {{
      selectedOption === EServiceChangeRequestToggleHeaders.PREVIEW ||
      selectedOption === EServiceChangeRequestToggleHeaders.CODE_EDITOR
        ? 'flex-grow-1'
        : changeRequestStatus === EServiceChangeRequestStatus.IN_REDEVELOPMENT
        ? 'w-50'
        : 'w-75'
    }}">
    <div
      class="irembogov-configuration-workflow-json-editor-form mt-5 container">
      <div class="col mx-auto">
        <div #errorMessageElement>
          <irembogov-irembo-section-message
            *ngIf="showConfigWorkflowErrorMessage"
            [type]="formAlertContent.type"
            [title]="formAlertContent.title"
            [message]="formAlertContent.message"
            [extraMessage]="formAlertContent.extraMessage"
            [extraMessageAsHtml]="true"></irembogov-irembo-section-message>
        </div>
        <div class="main">
          <div [hidden]="currentConfigStep !== 0">
            <ng-container [ngTemplateOutlet]="workflowConfig"></ng-container>
          </div>
          <div [hidden]="currentConfigStep !== 1">
            <ng-container [ngTemplateOutlet]="workflowSla"></ng-container>
          </div>
          <div [hidden]="currentConfigStep !== 2">
            <ng-container
              [ngTemplateOutlet]="workflowNotification"></ng-container>
          </div>
          <div [hidden]="currentConfigStep !== 3">
            <ng-container
              [ngTemplateOutlet]="workflowOfficerAssignment"></ng-container>
          </div>
          <div [hidden]="currentConfigStep !== 4">
            <ng-container
              [ngTemplateOutlet]="workflowIntegrations"></ng-container>
          </div>
          <div [hidden]="currentConfigStep !== 5">
            <ng-container [ngTemplateOutlet]="workflowDocuments"></ng-container>
          </div>
          <div [hidden]="currentConfigStep !== 6">
            <ng-container [ngTemplateOutlet]="workflowReminders"></ng-container>
          </div>
          <div [hidden]="currentConfigStep !== 7">
            <ng-container
              [ngTemplateOutlet]="workflowRestrictions"></ng-container>
          </div>
          <div [hidden]="currentConfigStep !== 8">
            <ng-container
              [ngTemplateOutlet]="workflowReceiptName"></ng-container>
          </div>
        </div>
        <div class="text-end">
          <button
            class="btn btn-primary mt-1 mx-auto px-5"
            type="submit"
            [disabled]="
              isLoading ||
              jsonEditorValidationErrors.length > 0 ||
              (!jsonEditor && !workflowBuilderV2Enabled) ||
              nextSteps.length === 0 ||
              !nextStepsForm.valid ||
              !slaForm.valid
            "
            (click)="onWorkflowSubmit()">
            <div
              *ngIf="isLoading"
              class="spinner-border spinner-border-sm mr-2"
              role="status"></div>
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="pt-5 ms-3 me-3 w-25"
    *ngIf="
      changeRequestStatus === EServiceChangeRequestStatus.IN_REDEVELOPMENT
    ">
    <irembogov-service-change-request-feedback-handler-widget
      *ngIf="changeRequest"
      [changeRequestId]="changeRequest.id ?? ''"
      [serviceChangeRequestSection]="
        EServiceChangeRequestSection.WORKFLOW
      "></irembogov-service-change-request-feedback-handler-widget>
  </div>
</div>
<ng-template #workflowConfig>
  <ng-container>
    <div
      class="workflow_step mb-5 step-1"
      *ngIf="!(workflowBuilderV2Enabled && useWorkflowBuilderV2)">
      <h5 class="text-primary">Select Workflow</h5>
      <div class="workflow_step_body">
        <irembogov-workflow-template-selector-list-widget
          (selectWorkflowTemplateChange)="
            onSelectWorkflowTemplate($event)
          "></irembogov-workflow-template-selector-list-widget>
      </div>
    </div>
  </ng-container>
  <ng-container jsoneditor>
    <div
      *ngIf="!workflowBuilderV2Enabled"
      class="workflow_step mb-5 step-2 {{
        selectedOption === EServiceChangeRequestToggleHeaders.CODE_EDITOR
          ? 'd-block'
          : 'd-none'
      }}">
      <h5 class="text-primary">Workflow Editor</h5>
      <div class="workflow_step_body">
        <div class="mb-3">
          <div class="form-group">
            <label for="jsonWorkflowData" class="form-label">
              Workflow Editor
              <i
                class="fa-solid fa-circle-info text-muted"
                placement="top"
                ngbTooltip="Build form with Json"></i>
            </label>
            <div class="input-group mb-3">
              <json-editor
                [options]="editorOptions"
                id="jsonWorkflowData"
                class="form-control p-0 json-form-data-field"
                (change)="validateJsonEditor()"
                (keyup)="validateJsonEditor()"
                [data]="initialData ? initialData : {}"
                #jsonWorkflowData>
              </json-editor>
            </div>
            <div
              class="form-error w-100 small text-danger"
              *ngIf="jsonEditorValidationErrors.length > 0">
              JSON input is invalid
              <ol>
                <li
                  class="w-100 small"
                  *ngFor="
                    let error of jsonEditorValidationErrors;
                    let index = index
                  ">
                  <em class="text-muted"> Line {{ error['line'] }}</em>
                  <br />
                  <small [innerHTML]="error['message']"></small>
                </li>
              </ol>
            </div>
            <div
              class="form-error w-100 small text-danger"
              *ngIf="!jsonWorkflowData">
              Please enter a JSON Workflow entry
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container #visualEditor>
    <div
      *ngIf="
        (selectedOption === EServiceChangeRequestToggleHeaders.PREVIEW ||
          selectedOption === EServiceChangeRequestToggleHeaders.CODE_EDITOR) &&
        changeRequestJsonWorkflowData
      "
      class="workflow_step mb-5 step-2 {{
        selectedOption === EServiceChangeRequestToggleHeaders.PREVIEW ||
        selectedOption === EServiceChangeRequestToggleHeaders.CODE_EDITOR
          ? 'd-block'
          : 'd-none'
      }}">
      <h5 class="text-primary">
        Workflow Editor
        <button
          *ngIf="
            workflowBuilderV2Enabled &&
            selectedOption === EServiceChangeRequestToggleHeaders.PREVIEW
          "
          type="button"
          class="btn btn-sm btn-outline-primary ml-3"
          (click)="toggleWorkflowBuilderVersion()">
          {{
            useWorkflowBuilderV2
              ? '← Classic editor'
              : '◆ Try the new builder (v2)'
          }}
        </button>
      </h5>
      <div
        #statePreviewer
        class="workflow_step_body w-100 mb-3"
        style="height: 80vh">
        <irembogov-workflow-builder-v2
          *ngIf="
            workflowBuilderV2Enabled &&
            (useWorkflowBuilderV2 ||
              selectedOption === EServiceChangeRequestToggleHeaders.CODE_EDITOR)
          "
          [workflowJson]="changeRequestJsonWorkflowData"
          [jsonEditorInitiallyOpen]="
            selectedOption === EServiceChangeRequestToggleHeaders.CODE_EDITOR
          "
          [formFields]="formFields"
          [organizationId]="changeRequest?.organizationId"
          (workflowJsonChange)="
            onWorkflowUpdate($event)
          "></irembogov-workflow-builder-v2>
        <irembogov-state-machine-preview
          *ngIf="
            selectedOption === EServiceChangeRequestToggleHeaders.PREVIEW &&
            !(workflowBuilderV2Enabled && useWorkflowBuilderV2)
          "
          [workflowCode]="changeRequestJsonWorkflowData['workflow']"
          (workflowUpdated)="
            onWorkflowUpdate($event)
          "></irembogov-state-machine-preview>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      selectedOption === EServiceChangeRequestToggleHeaders.WIZARD &&
      changeRequestJsonWorkflowData
    "
    #nextSteps>
    <div class="workflow_step mb-5 step-2">
      <h5 class="text-primary">Next steps page</h5>
      <div class="workflow_step_body">
        <div class="mb-3">
          <div class="form-group">
            <label for="jsonWorkflowData" class="form-label">
              When necessary Edit the text with useful information for the
              applied citizen
              <i
                class="fa-solid fa-circle-info text-muted"
                placement="top"
                ngbTooltip="Configure next steps"></i>
            </label>
            <form
              [formGroup]="nextStepsForm"
              *ngIf="changeRequestJsonWorkflowData">
              <div class="form-group">
                <div formArrayName="nextSteps">
                  <div
                    *ngFor="
                      let stepForm of getSteps(nextStepsForm);
                      let i = index;
                      let step = index
                    ">
                    <div [formGroupName]="i">
                      <p class="p-2">
                        Step {{ step + 1 }}
                        <i
                          class="fa-solid fa-circle-info text-muted"
                          placement="top"
                          ngbTooltip="Step {{ step + 1 }}"></i>
                      </p>
                      <div class="d-flex">
                        <div class="form-group col-md-10">
                          <label class="text-muted form-label"
                            >Title<i class="text-muted pl-3" placement="top"></i
                          ></label>
                          <input
                            type="text"
                            class="form-control mb-2"
                            placeholder="Title"
                            formControlName="title" />
                        </div>
                        <span class="text-muted ms-auto">
                          <a
                            style="cursor: pointer"
                            (click)="removeNextStep(i)">
                            <i class="fa fa-trash-alt"></i>
                          </a>
                        </span>
                      </div>
                      <div class="form-group">
                        <label class="text-muted form-label"
                          >Description<i
                            class="text-muted pl-3"
                            placement="top"></i
                        ></label>
                        <quill-editor
                          #editor
                          format="html"
                          [modules]="quillConfig"
                          [style.display]="hide ? 'none' : 'block'"
                          class="bg-white rounded-lg border border-light"
                          [styles]="{ backgroundColor: backgroundColor }"
                          formControlName="description"
                          [required]="true"
                          placeholder="Step description">
                        </quill-editor>
                      </div>
                      <div class="form-group mt-2">
                        <label class="text-muted form-label"
                          >Condition<i
                            class="text-muted pl-3"
                            placement="top"></i
                        ></label>
                        <input
                          type="textarea"
                          class="form-control mb-2"
                          placeholder="Condition"
                          formControlName="condition" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                class="btn btn-primary btn-sm mt-3"
                (click)="addNextStep()">
                <i class="fas fa-plus"></i> Add Step
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
<ng-template #workflowSla>
  <div class="mb-3 step-1">
    <h5 class="text-primary">SLA of status changes</h5>
    <div class="body">
      <form [formGroup]="slaForm">
        <div class="form-group">
          <label for="jsonWorkflowData" class="form-label text-muted">
            Overall SLA
            <i
              class="fa-solid fa-circle-info text-muted"
              placement="top"
              ngbTooltip="Overall SLA"></i>
          </label>
          <div class="row">
            <div class="col">
              <input
                type="number"
                class="form-control"
                id="expectedProcessingTime"
                placeholder="Expected processing time"
                formControlName="expectedProcessingTime" />
            </div>
            <div class="col">
              <ng-select
                ngDefaultControl
                id="expectedProcessingMeasurementUnit"
                class="processing-unit"
                formControlName="expectedProcessingMeasurementUnit"
                placeholder="Select a processing unit"
                [items]="processingMeasurementUnits"
                bindLabel="label"
                bindValue="value">
              </ng-select>
            </div>
          </div>
          <small class="text-primary"
            ><i
              >This text will be displayed to the citizen to communicate the
              duration of the process</i
            ></small
          >
        </div>
      </form>
    </div>
  </div>
</ng-template>
<ng-template #workflowNotification>
  <irembogov-notification-configuration
    *ngIf="changeRequestJsonWorkflowData && changeRequest"
    [changeRequestJsonWorkflowData]="changeRequestJsonWorkflowData"
    [formFields]="formFields"
    (workflowUpdated)="
      onWorkflowUpdate($event)
    "></irembogov-notification-configuration>
</ng-template>
<ng-template #workflowOfficerAssignment
  ><irembogov-office-assignment-config
    *ngIf="changeRequestJsonWorkflowData && changeRequest"
    [changeRequestJsonWorkflowData]="changeRequestJsonWorkflowData"
    [organizationId]="changeRequest.organizationId"
    (workflowUpdated)="onWorkflowUpdate($event)">
  </irembogov-office-assignment-config
></ng-template>
<ng-template #workflowIntegrations></ng-template>
<ng-template #workflowDocuments>
  <irembogov-irembogov-certificate-list
    *ngIf="changeRequest"
    [organizationId]="
      changeRequest.organizationId
    "></irembogov-irembogov-certificate-list>
</ng-template>
<ng-template #workflowReminders>
  <irembogov-configure-reminders></irembogov-configure-reminders>
</ng-template>

<ng-template #workflowRestrictions>
  <irembogov-restrictions-configuration
    *ngIf="changeRequestJsonWorkflowData && changeRequest"
    [changeRequestJsonWorkflowData]="changeRequestJsonWorkflowData"
    [changeRequest]="changeRequest"
    (workflowUpdated)="onWorkflowUpdate($event)">
  </irembogov-restrictions-configuration>
</ng-template>

<ng-template #workflowReceiptName>
  <irembogov-configuration-receipt-name
    *ngIf="changeRequestJsonWorkflowData"
    [formFields]="formFields"
    [changeRequestJsonWorkflowData]="changeRequestJsonWorkflowData"
    (workflowUpdated)="onWorkflowUpdate($event)">
  </irembogov-configuration-receipt-name>
</ng-template>
